import Dialog from "components/Overlays/ResponsiveDialog";

const ModalNotification = ({ title, visible, setVisible, children }) => {
  return (
    <Dialog sheet={false}
      visible={visible}
      header={<div className="text-center">{title}</div>}
      onHide={() => setVisible(false)}
    >
      {children}
    </Dialog>
  );
};

export default ModalNotification;
